<app-auth-navbar></app-auth-navbar>
<div class="container">
    <div class="row">
        <div class="col-lg-4 col-md-6 col-12 mx-auto" style="margin-top: 140px;">
            <form #formData="ngForm" (ngSubmit)="resetPassword(formData)" >
                <h3 class="signin_heading custom-heading text-center">Reset your password</h3>
                <br>
                <div class="text-center">
                    <p class="signin__text">If you have forgotten your password,<br>enter your email below to reset it.</p>
                </div>
                <div class="form-group my-4">
                    <input #resetEmail="ngModel" pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" type="email" class="form-control input_figma sm-16" name="email" [(ngModel)]="resetMail"
                        placeholder="Enter your email address"  required>
                </div>
                <button type="submit" class="btn primary-btn reset__btn w-100 border-0 button_figma h-auto" [disabled]="!resetEmail.valid || resetMail.length==0">
                    Reset my password
                </button>
            </form>
        </div>
    </div>
</div>